module.exports = new __parcel__URL__("flag-disabled.813c2320.svg").toString();